// import { useState, useEffect } from 'react'
// import { KTCard } from '../../../../../../_metronic/helpers'
// import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
// import { useQuery } from 'react-query'
// import DatePicker from 'react-datepicker'
// import 'react-datepicker/dist/react-datepicker.css'
// import axios from 'axios'
// import { Modal } from 'react-bootstrap'
// import RemarksModalForm from '../../../data-administration/data-admininstration-list/form-edit-modal/PricingModalFormTemplate'

// const PricingWrapper1 = () => {
//   // Base API URL from environment variable
//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL

//   // State for form values
//   const [formValues, setFormValues] = useState({
//     recyclerId: '',
//     pickupPointId: '',
//     startDate: null,
//     endDate: null,
//     structureId: ''
//   });

//   // State for API data with proper typing
//   interface TableRow {
//     orderId?: string;
//     supplyPartner?: string;
//     recycler?: string;
//     currentLocation?: string;
//     lastUpdated?: string;
//     category?: string;
//     categoryName?: string;
//     item?: string;
//     unit?: string;
//     price?: string;
//     currency?: string;
//     template?: string;
//     [key: string]: any; // Allow for additional properties
//   }

//   const [tableData, setTableData] = useState<TableRow[]>([]);

//   // Define proper type for structures
//   interface Structure {
//     id: string;
//     name: string;
//     [key: string]: any; // Allow for additional properties
//   }

//   // Define proper type for categories
//   interface Category {
//     id: string;
//     name: string;
//     [key: string]: any; // Allow for additional properties
//   }

//   // State for structures data with proper typing
//   const [structures, setStructures] = useState<Structure[]>([]);

//   // State for categories data with proper typing
//   const [categories, setCategories] = useState<Category[]>([]);

//   // State to track if data has been loaded
//   const [dataLoaded, setDataLoaded] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   // Modal state and handlers
//   const [showModal, setShowModal] = useState(false);
//   const [isUserLoading, setIsUserLoading] = useState(false);

//   // Function to close the modal
//   const handleCloseModal = () => {
//     setShowModal(false);
//   };

//   // Function to open the modal
//   const handleShowModal = () => {
//     setShowModal(true);
//   };

//   // Function to fetch categories
//   const fetchCategories = async () => {
//     try {
//       const response = await axios.get(`${BASE_API_URL}clients/101212/categories`);
//       const categoriesData = response.data?.data || [];
//       setCategories(categoriesData);
//       console.log('Categories data:', categoriesData);
//     } catch (error) {
//       console.error('Error fetching categories:', error);
//     }
//   };

//   // Fetch categories on component mount
//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   // Fetch structures data using useQuery
//   const { data: structuresData, isLoading: structuresLoading } = useQuery(
//     ['structures'],
//     async () => {
//       // Using axios with the specified base URL
//       const response = await axios.get(`${BASE_API_URL}structures`);
//       return response.data;
//     },
//     {
//       cacheTime: 0,
//       onError: (err) => {
//         console.warn('Error fetching structures:', err);
//       },
//       onSuccess: (data) => {
//         // Assuming the API returns an object with a data property
//         setStructures(data?.data || []);
//         console.log('Structures data:', data);
//       }
//     }
//   );

//   // Function to fetch category data for each category ID
//   const fetchCategoryData = async (structureId: string) => {
//     if (!structureId || categories.length === 0) return;

//     setIsLoading(true);
//     setTableData([]);
//     setDataLoaded(false);

//     try {
//       // Create an array of promises for each category
//       const promises = categories.map(category =>
//         axios.get(`${BASE_API_URL}categories/${category.id}/price?templateId=${structureId}`)
//       );

//       // Wait for all promises to resolve
//       const responses = await Promise.all(promises);

//       // Process all the responses and combine the data
//       let allData: TableRow[] = [];

//       responses.forEach((response, index) => {
//         const categoryData = response.data?.data || [];
//         const currentCategory = categories[index];

//         // Map the API response to table rows
//         const categoryRows = categoryData.map((item: any) => ({
//           category: currentCategory.id,
//           categoryName: currentCategory.name,
//           itemName: item.itemName || '',
//           unit: item.unit || '',
//           price: item.price || '',
//           currency: item.currency || '',
//           template: item.template || ''
//         }));

//         allData = [...allData, ...categoryRows];
//       });

//       setTableData(allData);
//       setDataLoaded(true);
//       console.log('All category data:', allData);
//     } catch (error) {
//       console.error('Error fetching category data:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   console.log("setTableData", tableData)



//   // Handle form value changes
//   const handleInputChange = (field: string, value: any) => {
//     setFormValues(prev => ({ ...prev, [field]: value }));

//     // If the structure ID has changed, fetch category data
//     if (field === 'structureId' && value) {
//       fetchCategoryData(value);
//     }
//   };

//   return (
//     <KTCard>
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: '100px', width: '100%' }}>
//         {/* Search bar and structure dropdown */}
//         <div style={{ paddingLeft: "20px", marginTop: "60px" }}>
//           <div className='grid grid-cols-4 gap-3 my-2'>
//             {/* Structure Dropdown */}
//             <div>
//               {/* <label className="form-label">Structure</label> */}
//               <select
//                 className="form-select form-select-solid"
//                 value={formValues.structureId}
//                 onChange={(e) => handleInputChange('structureId', e.target.value)}
//                 disabled={structuresLoading}
//               >
//                 <option value="">Select</option>
//                 {structures && structures.map((structure) => (
//                   <option key={structure.id} value={structure.id}>
//                     {structure.name}
//                   </option>
//                 ))}
//               </select>
//               {structuresLoading && <span className="text-dark fs-7">Loading structures...</span>}
//             </div>
//           </div>
//         </div>

//         {/* Create Template Button */}
//         <div style={{ paddingRight: "20px", marginTop: "60px" }}>
//           <button
//             className="btn btn-primary"
//             onClick={handleShowModal}
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '5px',
//               backgroundColor: '#12b886',
//               borderColor: '#000'
//             }}
//           >
//             <span style={{ fontSize: '16px', fontWeight: 'bold' }}>+</span>
//             Create Template
//           </button>
//         </div>
//       </div>

//       <div className='table-responsive' style={{ margin: "50px 0" }}>
//         {isLoading && (
//           <div className="d-flex justify-content-center my-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//           </div>
//         )}

//         {!isLoading && (
//           <>
//             <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
//               <thead>
//                 <tr className='text-left text-white fw-bolder fs-7  gs-0' style={{ backgroundColor: '#333333' }}>
//                   <th>S.N</th>
//                   <th>Category</th>
//                   <th>Item</th>
//                   <th>Unit</th>
//                   <th>Price</th>
//                   <th>Currency</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {dataLoaded && tableData.length > 0 ? (
//                   tableData.map((row, index) => (
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                       <td>
//                         <span style={{
//                           padding: '3px',
//                           borderRadius: '4px',
//                           backgroundColor: '#f8f5ff',
//                           color: '#7239ea',
//                           fontWeight: "bold"
//                         }}> {row.categoryName || '-'}</span>
//                       </td>
//                       <td>{row.itemName || '-'}</td>
//                       <td>{row.unit || '-'}</td>
//                       <td>{row.price || '-'}</td>
//                       <td>{row.currency || '-'}</td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={7} className="text-center">
//                       {formValues.structureId ? 'No data available for the selected structure' : 'Please select a structure to view data'}
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>

//             {/* No pagination needed */}
//           </>
//         )}
//       </div>

//       {/* Modal for Create Template */}
//       <Modal
//         show={showModal}
//         onHide={handleCloseModal}
//         size="lg"
//         aria-labelledby="contained-modal-title-vcenter"
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title id="contained-modal-title-vcenter">
//             Create Template
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <RemarksModalForm isUserLoading={isUserLoading} />
//         </Modal.Body>
//         <Modal.Footer>
//           <button className="btn btn-secondary" onClick={handleCloseModal}>
//             Close
//           </button>
//           <button className="btn btn-primary" onClick={handleCloseModal}>
//             Save
//           </button>
//         </Modal.Footer>
//       </Modal>
//     </KTCard>
//   );
// };

// export { PricingWrapper1 };





import { useState, useEffect } from 'react'
import { KTCard } from '../../../../../../_metronic/helpers'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
import { useQuery } from 'react-query'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import axios from 'axios'
import { Modal } from 'react-bootstrap'
import RemarksModalForm from '../../../data-administration/data-admininstration-list/form-edit-modal/PricingModalFormTemplate'
import PriceTemplateEditForm from '../../../data-administration/data-admininstration-list/form-edit-modal/PriceTemplateEditForm'
// Import your edit component here
// import EditTemplateForm from '../../../path/to/your/EditTemplateForm'

const PricingWrapper1 = () => {
  // Base API URL from environment variable
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL

  // State for form values
  const [formValues, setFormValues] = useState({
    recyclerId: '',
    pickupPointId: '',
    startDate: null,
    endDate: null,
    structureId: ''
  });

  // State for API data with proper typing
  interface TableRow {
    orderId?: string;
    supplyPartner?: string;
    recycler?: string;
    currentLocation?: string;
    lastUpdated?: string;
    category?: string;
    categoryName?: string;
    item?: string;
    unit?: string;
    price?: string;
    currency?: string;
    template?: string;
    [key: string]: any; // Allow for additional properties
  }

  const [tableData, setTableData] = useState<TableRow[]>([]);

  // Define proper type for structures
  interface Structure {
    id: string;
    name: string;
    [key: string]: any; // Allow for additional properties
  }

  // Define proper type for categories
  interface Category {
    id: string;
    name: string;
    [key: string]: any; // Allow for additional properties
  }

  // State for structures data with proper typing
  const [structures, setStructures] = useState<Structure[]>([]);

  // State for categories data with proper typing
  const [categories, setCategories] = useState<Category[]>([]);

  // State to track if data has been loaded
  const [dataLoaded, setDataLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Modal state and handlers for Create Template
  const [showModal, setShowModal] = useState(false);
  const [isUserLoading, setIsUserLoading] = useState(false);

  // Modal state and handlers for Edit Template
  const [showEditModal, setShowEditModal] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  // Function to close the modals
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  // Function to open the modals
  const handleShowModal = () => {
    setShowModal(true);
  };

  // const handleShowEditModal = () => {
  //   setIsEditLoading(true);

  //   // Simulate loading if needed
  //   setTimeout(() => {
  //     setIsEditLoading(false);
  //   }, 500);

  //   setShowEditModal(true);
  // };

  const handleShowEditModal = () => {
    if (!formValues.structureId || tableData.length === 0) {
      alert('Please select a structure and ensure data is loaded before editing.');
      return;
    }
    setShowEditModal(true);
  };

  // Function to fetch categories
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${BASE_API_URL}clients/101212/categories`);
      const categoriesData = response.data?.data || [];
      setCategories(categoriesData);
      console.log('Categories data:', categoriesData);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  // Fetch categories on component mount
  useEffect(() => {
    fetchCategories();
  }, []);

  // Fetch structures data using useQuery
  const { data: structuresData, isLoading: structuresLoading } = useQuery(
    ['structures'],
    async () => {
      // Using axios with the specified base URL
      const response = await axios.get(`${BASE_API_URL}structures`);
      return response.data;
    },
    {
      cacheTime: 0,
      onError: (err) => {
        console.warn('Error fetching structures:', err);
      },
      onSuccess: (data) => {
        // Assuming the API returns an object with a data property
        setStructures(data?.data || []);
        console.log('Structures data:', data);
      }
    }
  );

  // Function to fetch category data for each category ID
  const fetchCategoryData = async (structureId: string) => {
    if (!structureId || categories.length === 0) return;

    setIsLoading(true);
    setTableData([]);
    setDataLoaded(false);

    try {
      const promises = categories.map(category =>
        axios.get(`${BASE_API_URL}categories/${category.id}/price?structureId=${structureId}`)
      );
      const responses = await Promise.all(promises);
      let allData: TableRow[] = [];
      responses.forEach((response, index) => {
        const categoryData = response.data?.data || [];
        const currentCategory = categories[index];

        // Map the API response to table rows
        const categoryRows = categoryData.map((item: any) => ({
          category: currentCategory.id,
          categoryName: currentCategory.name,
          itemName: item.itemName || '',
          itemId: item.itemId || '', // ← Add this line
          unit: item.unit || '',
          price: item.price || '',
          currency: item.currency || '',
          template: item.template || ''
        }));

        allData = [...allData, ...categoryRows];
      });

      setTableData(allData);
      setDataLoaded(true);
      console.log('All category data:', allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // console.log("setTableData", tableData)



  // Handle form value changes
  const handleInputChange = (field: string, value: any) => {
    setFormValues(prev => ({ ...prev, [field]: value }));

    // If the structure ID has changed, fetch category data
    if (field === 'structureId' && value) {
      fetchCategoryData(value);
    }
  };

  return (
    <KTCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: '100px', width: '100%' }}>
        {/* Search bar and structure dropdown */}
        <div style={{ paddingLeft: "20px", marginTop: "60px" }}>
          <div className='grid grid-cols-4 gap-3 my-2'>
            {/* Structure Dropdown */}
            <div>
              {/* <label className="form-label">Structure</label> */}
              <p style={{ fontSize: "15px", fontWeight: "bold" }}>Select template</p>
              <select
                style={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #dddddd',
                  color: '#000000', // Text color for selected option
                }}
                className="form-select form-select-solid"
                value={formValues.structureId}
                onChange={(e) => handleInputChange('structureId', e.target.value)}
                disabled={structuresLoading}
              >
                <option value="">Select</option>
                {structures && structures.map((structure) => (
                  <option key={structure.id} value={structure.id}>
                    {structure.name}
                  </option>
                ))}
              </select>
              {structuresLoading && <span className="text-dark fs-7">Loading structures...</span>}
            </div>
          </div>
        </div>

        {/* Buttons Container */}
        <div style={{
          paddingRight: "20px",
          marginTop: "60px",
          display: 'flex',
          gap: '10px'
        }}>
          {/* Edit Button */}
          {/* <button
            className="btn btn-primary"
            onClick={handleShowEditModal}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              backgroundColor: '#12b886',
              borderColor: '#000'
            }}
          >
            Edit
          </button> */}

          {/* Create Template Button */}
          <button
            className="btn btn-primary"
            onClick={handleShowModal}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              // backgroundColor: 'black',
              // borderColor: '#000',
              // color: 'white'
            }}
          >
            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>+</span>
            Create template
          </button>
          <button
            className="btn btn-primary"
            onClick={handleShowEditModal}
            disabled={!formValues.structureId || !dataLoaded || tableData.length === 0}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              // backgroundColor: '#f39c12',
              // borderColor: '#000'
            }}
          >
            Edit template
          </button>
        </div>
      </div>

      <div className='table-responsive' style={{ margin: "50px 0" }}>
        {isLoading && (
          <div className="d-flex justify-content-center my-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        {!isLoading && (
          <div style={{ paddingLeft: '30px', paddingRight: '30px' }}>

            <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
              <thead>
                <tr className='text-left text-white fw-bolder fs-7 gs-0' style={{ backgroundColor: '#333333' }}>
                  <th>S.N</th>
                  <th>Category</th>
                  <th>Item</th>
                  <th>Unit</th>
                  <th>Price</th>
                  <th>Currency</th>
                </tr>
              </thead>
              <tbody>
                {dataLoaded && tableData.length > 0 ? (
                  tableData.map((row, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <span style={{
                          padding: '3px',
                          borderRadius: '4px',
                          backgroundColor: '#f8f5ff',
                          color: '#7239ea',
                          fontWeight: "bold"
                        }}> {row.categoryName || '-'}</span>
                      </td>
                      <td>{row.itemName || '-'}</td>
                      <td>{row.unit || '-'}</td>
                      <td>{row.price || '-'}</td>
                      <td>{row.currency || '-'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      {formValues.structureId ? 'No data available for the selected structure' : 'Please select a structure to view data'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>


          </div>
        )}
      </div>


      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Create template
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RemarksModalForm isUserLoading={isUserLoading} onClose={handleCloseModal} />
        </Modal.Body>
        <Modal.Footer>
          {/* <button className="btn btn-secondary" onClick={handleCloseModal}>
            Close
          </button>
          <button className="btn btn-primary" onClick={handleCloseModal}>
            Save
          </button> */}
        </Modal.Footer>
      </Modal>




      {/* Modal for Edit Template */}
      {/* <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        size="lg"
        aria-labelledby="edit-modal-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="edit-modal-title">
            Edit Template
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PriceTemplateEditForm isUserLoading={isUserLoading} />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleCloseEditModal}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleCloseEditModal}
            style={{ backgroundColor: '#0f95b0', borderColor: '#0f95b0' }}
          >
            Update
          </button>
        </Modal.Footer>
      </Modal> */}





      {/* Modal for Edit Template */}
      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        size="lg"
        aria-labelledby="edit-modal-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="edit-modal-title">
            Edit Template
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PriceTemplateEditForm
            isUserLoading={isEditLoading}
            structureId={formValues.structureId}
            structureName={structures.find(s => s.id === formValues.structureId)?.name || ''}
            tableData={tableData}
            onClose={handleCloseEditModal}
          />
        </Modal.Body>
        <Modal.Footer>
          {/* Footer content will be handled by the form component */}
        </Modal.Footer>
      </Modal>





    </KTCard>
  );
};

export { PricingWrapper1 };